exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".form-wrapper[data-v-6e575bd6]  .yxt-select{width:351px}.sel-type-item[data-v-6e575bd6]  .yxt-radio__label{display:inline-flex;align-items:center}.form-wrapper[data-v-6e575bd6]  .yxt-radio{line-height:40px}.wrapper[data-v-6e575bd6]{height:100%}.footer[data-v-6e575bd6]{position:absolute}.ta-c[data-v-6e575bd6]{text-align:center}\n", ""]);

